import ExpressPayments from './ExpressPayments';

export default ExpressPayments;
